import { CreateStrategyAssetCategory } from '../NewStrategy/types';
import SelectionButton from './Selection-button/Selection-button';

export const SelectionButtonGroup = ({
  currentSelection,
  selectionList,
  setCurrentSelection,
  className = '',
  cols = 2,
}: {
  className?: string;
  selectionList: CreateStrategyAssetCategory[];
  cols?: number;
  currentSelection?: CreateStrategyAssetCategory;
  setCurrentSelection(elem: CreateStrategyAssetCategory): void;
}) => {
  return currentSelection ? (
    <div className={`${className} grid gap-5 grid-cols-${cols}`}>
      {selectionList.map(({ address, id, title, logo }, i) => (
        <SelectionButton
          address={address}
          key={id}
          logo={logo}
          isSelected={currentSelection.id === id}
          label={title}
          onClick={() => setCurrentSelection(selectionList[i])}
        />
      ))}
    </div>
  ) : (
    <></>
  );
};
